/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCustomProperties = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 8h9V2H2zm2-4h5v2H4zm9-2v6h9V2zm7 4h-5V4h5zM2 15h9V9H2zm2-4h5v2H4zm9 4h9V9h-9zm2-4h5v2h-5zM2 22h9v-6H2zm2-4h5v2H4zm9 4h9v-6h-9zm2-4h5v2h-5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCustomProperties as CustomProperties };
